import angular from 'angular';

export default angular.module('shared').constant('sessionTypeConstants', {
    guest: 'guest'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/sessionType.constant.js